import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { killSeed } from 'modules/chats';
import { setBreadcrumb } from 'components/Navbar/modules';
import { goHome } from 'modules/steps/actions';
import { killThinkSeed, launchThinkTank } from '../modules/actions';
import Upgrade from '../components/Upgrade';

function mapStateToProps(state) {
  return {
    literals: state.i18n.literals.upgrade,
    color: state.app.color1,
    thinkChats: state.thinkChats.myThinkChatsList,
    user: state.session.user,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    setBreadcrumb: bindActionCreators(setBreadcrumb, dispatch),
    goHome: bindActionCreators(goHome, dispatch),
    killThinkSeed: bindActionCreators(killThinkSeed, dispatch),
    launchThinkTank: bindActionCreators(launchThinkTank, dispatch),
    killSeed: bindActionCreators(killSeed, dispatch),
  };
}

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(Upgrade),
);



// WEBPACK FOOTER //
// ./src/routes/Upgrade/container/index.js